'use strict'

let _qg = {},
doc = $(document),
win = $(window),
docHeight,
winHeight,
footerHeight,
goTopBtnHeight,
goTopBtnBottom,
coll_dc_access_id,
topTypeTxt01,
topTypeTxt02,
typeTxtAry = [];


_qg.ua = (function(){
	
	let _ua = navigator.userAgent.toLowerCase();
	let _o = {
		ltIE6:typeof window.addEventListener == "undefined" && typeof document.documentElement.style.maxHeight == "undefined",
		ltIE7:typeof window.addEventListener == "undefined" && typeof document.querySelectorAll == "undefined",
		ltIE8:typeof window.addEventListener == "undefined" && typeof document.getElementsByClassName == "undefined",
		IE9: navigator.appVersion.toLowerCase().indexOf("msie 9.") != -1,
		IE10 : navigator.userAgent.match(/Trident\/[6]/i),
		IE11: navigator.userAgent.match(/Trident\/7\./),
		IE:document.uniqueID,
		Firefox:window.sidebar,
		Opera:window.opera,
		chrome: _ua.indexOf('chrome') > -1,
		//Webkit:!document.uniqueID && !window.opera && !window.sidebar && !window.orientation && window.localStorage,
		mobile:/android|iphone|ipad|ipod/i.test(navigator.userAgent.toLowerCase()),
		iphone:/iphone|ipod/i.test(_ua),
		android:/android/.test(_ua),
		ipad:/ipad/.test(_ua),
		tablet:undefined,
		smartphone:undefined,
		touch: window.ontouchstart === null
	}
	_o.tablet = _o.ipad;
	if(!_o.tablet && _o.android){ _o.tablet = !(/mobile/.test(_ua));}				
	_o.smartphone = _o.iphone || _o.android ? true : false;
	
	let v = [];
	if (/iP(hone|od|ad)/.test(navigator.platform)) {v = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);}
	let vAry = [parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3] || 0, 10)];
	_o.iosV = vAry[0] ? vAry[0] : '';
	
	return _o;
})();



$(document).ready(()=>{

	win.on('resize load', resizeHandler);

	resizeHandler();

	$('.anchor, #g-nav a').on('click', (e)=>{
		
		let tar = $(e.currentTarget).attr('href');
		let str = tar.slice(0, 1);
		tar = tar.replace('#', '');
		if(str == '#'){
			e.preventDefault();
			let pos = 0;
			if(tar == 'header') {
				$('html,body').stop().animate({ scrollTop: pos }, 500, 'easeOutExpo');
			} else if($('[data-id="'+tar+'"]').length){
				let diff = $('.hamburger-button').is(':visible') ? 80 : 200;
				pos = $('[data-id="'+tar+'"]').offset().top - diff;
				$('html,body').stop().animate({ scrollTop: pos }, 500, 'easeOutExpo');
			}
			if($('.hamburger-button').is(':visible')){
				$('.hamburger-button').removeClass('opened');
				$('#g-nav').slideToggle();
			}
		}
	});	

	$('.hamburger-button').on('click', (e)=>{
		$(e.currentTarget).toggleClass('opened');
		$('#g-nav').slideToggle();
	});


	let st;
	win.on('scroll', (e)=>{
		st = win.scrollTop();

		if(docHeight - winHeight - footerHeight + (goTopBtnHeight / 2 + goTopBtnBottom) <= st) {
			let btnY = st - (docHeight - winHeight - footerHeight) - (goTopBtnHeight / 2);
			$('.go-top-button').css({bottom: btnY});
		} else {
			$('.go-top-button').css({bottom: ''});
		}
		if(st > 400){	
			$('.go-top-button').addClass('fade-in');
			$('.go-top-button').removeClass('fade-out');
		} else {
			if($('.go-top-button').is(':visible')){
				$('.go-top-button').removeClass('fade-in');
				$('.go-top-button').addClass('fade-out');
			}
		}
	}).trigger('scroll');	

	$('.form-wrapper .radios').each((i,elem)=>{
		let _self = elem;
		if($('input[type="radio"]', _self).is(':checked')){
			$('.radio', _self).removeClass('checked');
			$(_self).find('input:checked').prev('.radio').addClass('checked');			
		}		
		$('input[type="radio"]', _self).on('change', ()=>{
			$('.radio', _self).removeClass('checked');
			$(_self).find('input:checked').prev('.radio').addClass('checked');
		});
	});

	$('.questions dt').on('click', (e)=>{
		$(e.currentTarget).toggleClass('opened').next('dd').slideToggle(200, 'easeOutQuad');
	});

});

$.event.add(window, "load", ()=>{	
	
});

const resizeHandler = ()=>{
	docHeight = doc.height();
	winHeight = win.height();
	footerHeight = $('#footer').outerHeight();
	goTopBtnHeight = $('.go-top-button').outerHeight();
	goTopBtnBottom = Number($('.go-top-button').css('bottom').replace('px', ''));
	//console.log(goTopBtnBottom)
}
